import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import VolunteerStart from './VolunteerStart';

const PreloadScreen = () => {
    return (
        <Route
            render={({ location }) => (
                <TransitionGroup component={TransitionGroupContainer}>
                    <CssTransition key={location.key} timeoutInMs={650}>
                        <Switch location={location}>
                            <Route
                                path="/preload/volunteer"
                                name="VolunteerStart"
                                exact
                                component={VolunteerStart}
                            />
                        </Switch>
                    </CssTransition>
                </TransitionGroup>
            )}
        />
    );
};

export default PreloadScreen;



// WEBPACK FOOTER //
// ./src/containers/PreloadScreen/PreloadScreen.jsx